import { Users, Sparkles } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import type { WorldSetting } from "@/types/summary";
import { SettingCard } from "./SettingCard";

interface GlobalSettingCardProps {
  worldSetting: Pick<WorldSetting, "social_structure" | "metaphysics">;
}

export function GlobalSettingCard({ worldSetting }: GlobalSettingCardProps) {
  const { t } = useTranslation("jobDetails");
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <SettingCard
      accentBarClassName="bg-primary-400"
      headerContent={
        <Badge
          className="text-[0.6875rem] leading-4 font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full border-transparent bg-primary-25 text-primary-500"
          data-testid="global-badge"
        >
          {t("worldAndSettingCard.global")}
        </Badge>
      }
      preview={worldSetting.social_structure}
      expandedContent={
        <>
          <div className="space-y-1.5">
            <div className="flex items-center gap-1.5">
              <Users className="w-3.5 h-3.5 text-primary-500" />
              <span className="text-[0.75rem] font-semibold uppercase tracking-wide text-secondary-500">
                {t("worldAndSettingCard.socialStructure")}
              </span>
            </div>
            <p className="text-[0.875rem] leading-5 text-secondary-500 pl-5">
              {worldSetting.social_structure}
            </p>
          </div>

          <div className="space-y-1.5">
            <div className="flex items-center gap-1.5">
              <Sparkles className="w-3.5 h-3.5 text-primary-500" />
              <span className="text-[0.75rem] font-semibold uppercase tracking-wide text-secondary-500">
                {t("worldAndSettingCard.metaphysics")}
              </span>
            </div>
            <p className="text-[0.875rem] leading-5 text-secondary-500 pl-5">
              {worldSetting.metaphysics}
            </p>
          </div>
        </>
      }
      isExpanded={isExpanded}
      onToggle={() => setIsExpanded(!isExpanded)}
      testIds={{
        accentBar: "global-accent-bar",
        toggle: "global-setting-toggle",
        chevronRight: "global-chevron-right",
        chevronDown: "global-chevron-down",
        preview: "global-preview",
        content: "global-expanded-content",
      }}
    />
  );
}
